f
<script setup lang="ts">
  import { inject } from 'vue';

  import type { Attachment, Email } from '@stuut/api/models';
  import { toast } from '@ui/components/sonner';

  import { stuut } from '@/api';
  import AttachmentItem from '@/components/attachments/AttachmentItem.vue';
  import { FileDropzoneKey } from '@/components/file-upload-dropzone';
  import type { FileDropzoneProviderContext } from '@/components/file-upload-dropzone';

  interface Props {
    attachment: Attachment;
    email: Email;
  }

  const props = defineProps<Props>();

  const fileDropzone = inject<FileDropzoneProviderContext | undefined>(FileDropzoneKey, undefined);

  const handleDelete = async () => {
    const { email, attachment } = props;
    try {
      await stuut.emails.removeAttachment(email, attachment);
      fileDropzone?.removeFileAttachment(attachment);
    } catch (error: any) {
      const message =
        error.clientMessage ||
        'Failed to remove email attachment. Please try again, and contact support if the issue persists.';
      toast.error(message);
      console.error(message);
    }
  };
</script>

<template>
  <AttachmentItem
    truncate
    :attachment="attachment"
    :uploading="attachment.is_uploading"
    :hide-delete="false"
    @delete="handleDelete"
  />
</template>

<style scoped></style>
